import React, { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';

export const CompanySelector: React.FC = () => {
  const { user, switchCompany } = useAuth();

  useEffect(() => {
    console.log('[v0] CompanySelector state:', {
      currentCompanyId: user?.companyId,
      companies: user?.companies,
    });
  }, [user?.companyId, user?.companies]);

  const handleCompanyChange = (companyIdStr: string) => {
    const companyId = parseInt(companyIdStr, 10);
    console.log('[v0] CompanySelector - switching to company:', companyId);
    switchCompany(companyId);
  };

  // Show no companies state
  if (!user?.companies || user.companies.length === 0) {
    return (
      <div className="px-3 py-2 text-sm text-slate-400">
        Sin empresas
      </div>
    );
  }

  // Show selector
  return (
    <select
      value={user?.companyId ? String(user.companyId) : ''}
      onChange={(e) => handleCompanyChange(e.target.value)}
      className="px-3 py-2 text-sm bg-gray-700 text-white border border-gray-600 rounded hover:bg-gray-600 cursor-pointer"
    >
      <option value="">Selecciona empresa</option>
      {user.companies.map((company) => (
        <option key={company.id} value={String(company.id)}>
          {company.name}
        </option>
      ))}
    </select>
  );
};
